import { createFileRoute } from "@tanstack/react-router";

import { AgentCalibration } from "@/features/agent/AgentCalibration";

export const Route = createFileRoute("/agent/calibration")({
  component: AgentCalibration,
});
